import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, TemplateRef, ViewChild } from '@angular/core';
import { combineLatest, defer, iif, Observable, of, Subject } from 'rxjs';
import { Entidad } from 'src/app/auth/models/entidad.model';
import { EntidadService } from 'src/app/services/entidad.service';
import { map, switchMap } from 'rxjs/operators';
import { NbAuthService } from '@nebular/auth';
import { Multivalores, MultivaloresService, ValoresMultivalores } from 'src/app/services/multivalores.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GuardarMatrizDocumento, GuardarMatrizDocumentoVariables, MatrizDocumentoService, SubVariable, Variable } from 'src/app/services/matriz-documento.service';
import { Clipboard } from '@angular/cdk/clipboard';
import { AngularEditorComponent, AngularEditorConfig } from '@kolkov/angular-editor';
import { MatDialog } from '@angular/material/dialog';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GrupoVariables } from 'src/app/services/matriz-documento.service';





@Component({
  selector: 'slt-nuevo-documento',
  templateUrl: './nuevo-documento.component.html',
  styleUrls: ['./nuevo-documento.component.scss']
})
export class NuevoDocumentoComponent implements OnInit, AfterViewInit {


  @ViewChild('angularEditor') anE?: ElementRef;


  modalClass: string = 'modal';
  closeResult: string = '';

  //Variables inputs

  //Stage 1  
  nombre_doc?: string; //Nombre documento
  entidades$: Observable<Entidad[] | null>; //lista entidades
  selectedEntidad$: Observable<number | null>; //entidad seleccionada
  selectedEntidad!: number | null;
  TipoDocumento$: Observable<Multivalores[] | null | any[]>; // lista tipos documento
  TipoCampo$: Observable<Multivalores[] | null>; // lista tipos documento
  selectedTipoDocumento: any; //tipo documento seleccionado
  selectedVariablesList: any[] = [];



  //Stage 2
  grupoVariables: GrupoVariables[] = [];
  subVariables: SubVariable[] | undefined;
  selectedGrupoVariables?: number;
  selectedTipoCampo?: string;
  selectedSubVariable?: number;
  selectedSubVariableName: string = '';
  selectedSubVariableDesc: string = '';
  selectedSubVariableTipoDato: string = '';
  contenido?: string;
  nombre_NVariable: string = '';
  descripcion_NVariable: string = '';
  nombre_SubTabla: string = '';
  new_valor: string = '';
  new_descripcion: string = '';
  checked = false;
  agregarValores = false;
  valores_agregados: any[] = [];
  index_valores_agregados: number = 1;
  orden_valores_agregados: number = 1;
  tipo_parametro: string = "";
  createButton: boolean = false;
  TipoParametro$: Observable<Multivalores[] | null>;
  tipo_param_id: string = '';
  tipo_param_desc: string = '';
  selectedTipoParametro: any;
  VariablesSubject = new Subject<[ValoresMultivalores, Variable]>();
  MatrizDocSubject = new Subject<[GuardarMatrizDocumento, GuardarMatrizDocumentoVariables]>();
  tipo_campo: string = '';
  tipo_campo_desc: string = '';
  idVariablesList: number[] = [];
  id_subVariable: number | undefined;
  variable_final!: Variable;
  valores_multivalores_final !: ValoresMultivalores;
  matriz_documento_final!: GuardarMatrizDocumento;
  matriz_documento_variable_final!: GuardarMatrizDocumentoVariables;

  variables$: Observable<number | null>;
  matrizDocumento$: Observable<number[] | null>;
  iIDSubTabla?: number | null;
  dateType: boolean = false;
  stringValue: string = '';

  //fases 
  stage1: boolean = true; //Primera pantalla
  stage2: boolean = false; //Segunda pantalla



  constructor(
    entidadService: EntidadService,
    multivaloresService: MultivaloresService,
    nbAuthService: NbAuthService,
    matrizDocumentoService: MatrizDocumentoService,
    private _snackBar: MatSnackBar,
    private clipBoard: Clipboard,
    public dialog: MatDialog,
    private modalService: NgbModal
  ) {



    //Obtener  valores select

    this.TipoDocumento$ = multivaloresService.getMultivalores(11);
    this.TipoCampo$ = multivaloresService.getMultivalores(86);
    this.TipoParametro$ = multivaloresService.getMultivalores(86);
    this.entidades$ = entidadService.getEntidades();
    this.selectedEntidad$ = nbAuthService.onTokenChange().pipe(
      map(token => +token.getPayload().iIDEntidad)
    );
    this.selectedEntidad$.subscribe(x => {
      if (x) {
        this.selectedEntidad = x;
      }
    })

    matrizDocumentoService.GetGrupoVariable().subscribe(x => {
      if (x) {
        this.grupoVariables = x;
      }
    });

    const resVariables$ = this.VariablesSubject.asObservable().pipe(
      switchMap(a => combineLatest([
        of(a[1]),
        defer(() => a[1].tIDValorTipoCampo == "6" ? multivaloresService.AddValoresMultivalores(a[0]) : of(null))
      ])

      ),
      switchMap(b => combineLatest([
        of(b[1]),
        matrizDocumentoService.AddMatrizVariable({
          iIDSubTablaVariable: b[1] == null ? undefined : b[1],
          iIDSubTablaTipoCampo: b[0].iIDSubTablaTipoCampo,
          tDescripcionVariable: b[0].tDescripcionVariable,
          tNombreVariable: b[0].tNombreVariable,
          iIDMatrizGrupoVariable: b[0].iIDMatrizGrupoVariable,
          tIDValorTipoCampo: b[0].tIDValorTipoCampo

        })

      ])
      ),
      switchMap(([b, c]) =>
        of(b))

    );
    this.variables$ = resVariables$;


    const resMatrizDocumento$ = this.MatrizDocSubject.asObservable().pipe(
      switchMap(a => combineLatest([
        of(a[1]),
        matrizDocumentoService.AddMatrizDocumento(a[0])
      ])),
      switchMap(b =>
        defer(() => this.selectedVariablesList.length <= 0
          ? matrizDocumentoService.AddMatrizDocumentoVariables({
            iIDMatrizDocumento: b[1],
            idVariables: b[0].idVariables
          })
          : of(null)


        )));
    this.matrizDocumento$ = resMatrizDocumento$;

    this.stage1 = true;
    this.stage2 = false;


  }

  open(content: any) {
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  SaveNVariable() {

    if (this.nombre_NVariable == "") {
      this._snackBar.open("ERROR: Ingrese Nombre Variable", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
      return;
    }
    if (this.nombre_NVariable.indexOf(" ") != -1) {
      this._snackBar.open("ERROR: El nombre de la variable no puede tener espacios", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
      return
    }
    if (this.selectedTipoCampo == "" || this.selectedTipoCampo == undefined) {
      this._snackBar.open("ERROR: Seleccione un Tipo de Campo", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
      return;
    }
    if (this.descripcion_NVariable == "") {
      this._snackBar.open("ERROR: Ingrese una descripción", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
      return;
    }

    if (this.selectedTipoCampo === "6") {
      this.agregarValores = true;
      if (this.nombre_SubTabla == "") {
        this._snackBar.open("ERROR: Ingrese un nombre a la SubTabla", "X", {
          duration: 5000,
          horizontalPosition: "right",
          verticalPosition: "top"
        });
        return;
      }
      if (this.valores_agregados.length === 0) {
        this._snackBar.open("ERROR: No se han agregado valores a la tabla", "X", {
          duration: 5000,
          horizontalPosition: "right",
          verticalPosition: "top"
        });
        return;
      }
    }

    this.variable_final = {
      iIDMatrizGrupoVariable: this.selectedGrupoVariables,
      tNombreVariable: `{${this.nombre_NVariable}}`,
      iIDSubTablaTipoCampo: 86,
      tIDValorTipoCampo: this.selectedTipoCampo,
      tDescripcionVariable: this.descripcion_NVariable
    }


    this.valores_multivalores_final = {
      tSubTabla: this.nombre_SubTabla,
      Valores: this.valores_agregados
    }

    this.VariablesSubject.next([this.valores_multivalores_final, this.variable_final]);

    this.selectedVariablesList.push(
      [this.descripcion_NVariable, `{${this.nombre_NVariable}}`, this.tipo_campo_desc]
    );



    this.contenido += `{${this.nombre_NVariable}}`;
    this.CleanModal();
    this.modalService.dismissAll('Save click');
  }

  SaveTipoCampo(desc: string) {

    this.tipo_campo_desc = desc;
    if (this.selectedTipoCampo == "6") {
      this.agregarValores = true;

    } else {
      this.agregarValores = false;
    }
  }


  SendFormatDate(valor: Date | string) {
    if (typeof (valor) == 'object') {
      let dd = (new Date(valor)).getUTCDate().toString();
      let mm = ((new Date(valor)).getUTCMonth() + 1).toString();
      let yy = (new Date(valor)).getUTCFullYear().toString();

      this.stringValue = `${dd}/${mm}/${yy}`;
    } else {
      this.stringValue = valor;
    }
  }

  AddValor() {

    if (this.agregarValores) {
      if (this.new_descripcion == "" || this.new_descripcion == " ") {
        this._snackBar.open("ERROR: Ingrese descripción", "X", {
          duration: 5000,
          horizontalPosition: "right",
          verticalPosition: "top"
        });
        return;
      }

      if (this.tipo_param_id != "" && this.tipo_param_id != "-1") {

        if (this.tipo_param_id != "3") {
          if (this.new_valor == "") {
            this._snackBar.open("ERROR: Ingrese un valor", "X", {
              duration: 5000,
              horizontalPosition: "right",
              verticalPosition: "top"
            });
            return;
          }
        } else {
          this.new_valor = 'false';
        }

      }

    }

    this.SendFormatDate(this.new_valor);


    this.valores_agregados.push({
      Valor: this.new_valor, tDescripcionValor: this.new_descripcion,
      tIDValor: this.index_valores_agregados, iOrden: this.orden_valores_agregados,
      iTipoParametro: this.tipo_param_id, dTipoParametro: this.tipo_param_desc, stringDate: this.stringValue
    });

    this.new_valor = '';
    this.new_descripcion = '';
    this.tipo_param_desc = "";
    this.tipo_param_id = "-1";
    this.selectedTipoParametro = "-1";
    this.index_valores_agregados++;
    this.orden_valores_agregados = this.index_valores_agregados;

  }

  DeleteValor(id: number, arr: any[]) {
    arr.splice(id, 1);
  }
  DeleteValorMessage(id: number) {
    this._snackBar.open(`Por favor elimine la variable ${this.selectedVariablesList[id][1]} del documento`, "X", {
      duration: 7000,
      horizontalPosition: "right",
      verticalPosition: "top"
    });
  }

  Reordenar(arr: any[]) {

    for (let index = 0; index < arr.length; index++) {

      arr[index].tIDValor = index + 1;
      arr[index].iOrden = index + 1;


    }

    this.index_valores_agregados = arr.length + 1;
    this.orden_valores_agregados = this.index_valores_agregados



  }


  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }




  ChangeVariable(event: number | undefined, subVariable: number | undefined) {

    if (this.selectedGrupoVariables != undefined) {
      if (this.grupoVariables[this.selectedGrupoVariables - 1].descripcion == "Ejecucion") {
        this.createButton = true;
      } else {
        this.createButton = false;
      }

    }


    this.subVariables = this.grupoVariables?.find(x => x.id == event)?.children;

    if (subVariable)
      this.selectedSubVariable = subVariable;


  }


  ngOnInit(): void {
    this.variables$.subscribe(x => {
      if (x) {
        this.iIDSubTabla = x;
      }
      this._snackBar.open("Se ha creado la variable", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
    }
    );
    this.matrizDocumento$.subscribe(() => {
      this._snackBar.open("Se ha creado el documento", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
    }
    );

  }

  ngAfterViewInit(): void {

  }
  config: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '200px',
    maxHeight: 'auto',
    width: 'auto',
    minWidth: '0',
    showToolbar: true,
    sanitize: true,
    defaultParagraphSeparator: 'span',

  };

  openModal() {
    this.modalClass = 'showModal'
  }

  ClickSiguiente() {

    if (this.selectedTipoDocumento == undefined) {
      this._snackBar.open("Seleccione un tipo de documento valido", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
      return;
    }

    if (this.nombre_doc == undefined) {
      this._snackBar.open("Ingrese un nombre para el documento", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
      return;
    }

    this.stage1 = false;
    this.stage2 = true;
    this.contenido = "";


    // const angularEditor2 = angularEditor.getRootNode;




  }

  SaveValue(nombreVariable: string, descripcion: string, tipo_variable: string) {

    this.id_subVariable = this.selectedSubVariable;
    this.selectedSubVariableName = "";
    this.selectedSubVariableDesc = "";
    this.selectedSubVariableTipoDato = "";
    this.selectedSubVariableName = nombreVariable;
    this.selectedSubVariableDesc = descripcion;
    this.selectedSubVariableTipoDato = tipo_variable;
    this.selectedSubVariableName.trim();
    this.selectedSubVariableDesc.trim();


    if (this.selectedSubVariable)
      this.idVariablesList.push(this.selectedSubVariable);

  }

  CopyValue() {
    if (this.selectedSubVariable == undefined) {
      this._snackBar.open("Error: Por favor seleccione una Variable", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
      return;
    }

    this.clipBoard.copy(this.selectedSubVariableName);
    this.selectedVariablesList.push([this.selectedSubVariableDesc, this.selectedSubVariableName, this.selectedSubVariableTipoDato]);



    this._snackBar.open("Variable copiada en el portapapeles", "X", {
      duration: 5000,
      horizontalPosition: "right",
      verticalPosition: "top"
    });

    this.contenido?.trimEnd();
    this.contenido += this.selectedSubVariableName;

    // this.contenidoPreliminar = this.contenidoMostrar + this.selectedSubVariableName;
    // console.log(this.contenidoPreliminar);
    // this.contenidoMostrar = this.contenidoPreliminar;



  }

  CleanModal() {
    this.agregarValores = false;
    this.nombre_NVariable = '';
    this.selectedTipoCampo = '';
    this.new_descripcion = '';
    this.nombre_SubTabla = '';
    this.descripcion_NVariable = '';
    this.selectedTipoParametro = '';
    this.new_valor = '';
    this.valores_agregados = [];
    this.index_valores_agregados = 1;
    this.orden_valores_agregados = this.index_valores_agregados;


  }

  SaveTipo(id: string, descripcion: string) {

    this.tipo_param_id = id;
    this.tipo_param_desc = descripcion;


  }


  SaveMatrizDocumento() {
    console.log(this.selectedVariablesList.length);
    if (this.selectedVariablesList.length <= 0) {

      this._snackBar.open("ERROR: El contenido esta vacío", "X", {
        duration: 5000,
        horizontalPosition: "right",
        verticalPosition: "top"
      });
      return;
    }

    this.matriz_documento_final = {
      iIDEntidad: this.selectedEntidad,
      iIDSubTablaMatrizDocumentoTipo: 11,
      tIDValorMatrizDocumentoTipo: this.selectedTipoDocumento,
      tNombreDocumento: this.nombre_doc,
      tBodyDocumento: this.contenido,

    }

    this.matriz_documento_variable_final = {
      idVariables: this.idVariablesList
    }

    this.MatrizDocSubject.next([this.matriz_documento_final, this.matriz_documento_variable_final]);

  }

}
